import { render } from "./PhysicalFAQ.vue?vue&type=template&id=0ce8cd10&scoped=true"
import script from "./PhysicalFAQ.vue?vue&type=script&lang=js"
export * from "./PhysicalFAQ.vue?vue&type=script&lang=js"

import "./PhysicalFAQ.vue?vue&type=style&index=0&id=0ce8cd10&lang=scss&scoped=true"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ce8cd10"]])

export default __exports__